export function getAppBaseHref(): string {
	if (typeof document === "undefined") {
		return "/";
	}

	const raw = document.querySelector("base")?.getAttribute("href") ?? "/";
	if (raw === "/") {
		return "/";
	}

	return raw.endsWith("/") ? raw : `${raw}/`;
}

export function appPath(path: string): string {
	const segment = path.startsWith("/") ? path.slice(1) : path;
	const base = getAppBaseHref();

	if (base === "/") {
		return `/${segment}`;
	}

	return `${base}${segment}`;
}

export function appAbsoluteUrl(path: string): string {
	if (typeof window === "undefined") {
		return appPath(path);
	}

	return new URL(appPath(path), window.location.origin).href;
}
